import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "../pages/HomePage";

const ServicesPage = lazy(() => import("../pages/ServicesPage"));
const ContactPage = lazy(() => import("../pages/ContactPage"));
const LegalPage = lazy(() => import("../pages/LegalPage"));
const EventPage = lazy(() => import("../pages/EventPage"));
const VerificationSuccessPage = lazy(
  () => import("../pages/VerificationSuccessPage"),
);
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/app-services.html" element={<ServicesPage />} />
      <Route path="/contact" element={<ContactPage />} />

      <Route
        path="/privacy-policy"
        element={<LegalPage slug="privacy-policy" />}
      />
      <Route
        path="/privacy-policy.html"
        element={<LegalPage slug="privacy-policy" />}
      />
      <Route
        path="/terms-of-service"
        element={<LegalPage slug="terms-of-service" />}
      />
      <Route
        path="/terms-of-service.html"
        element={<LegalPage slug="terms-of-service" />}
      />
      <Route
        path="/community-legal"
        element={<LegalPage slug="community-legal" />}
      />
      <Route
        path="/community-legal.html"
        element={<LegalPage slug="community-legal" />}
      />
      <Route
        path="/data-deletion"
        element={<LegalPage slug="data-deletion" />}
      />
      <Route
        path="/data-deletion.html"
        element={<LegalPage slug="data-deletion" />}
      />

      <Route path="/events" element={<EventPage />} />
      <Route path="/events.html" element={<EventPage />} />
      <Route path="/events/index.html" element={<EventPage />} />
      <Route path="/events/:eventId" element={<EventPage />} />
      <Route path="/events/:eventId.html" element={<EventPage />} />
      <Route path="/event.html" element={<EventPage />} />

      <Route
        path="/verification-success"
        element={<VerificationSuccessPage />}
      />
      <Route
        path="/verification-success.html"
        element={<VerificationSuccessPage />}
      />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
